<template>
  <div class="visioncar-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/visioncar/banner.jpg" alt="">
    <div class="site-content">
      <div class="site-container">
        <h3 class="text-blue site-text__content_h3" style="margin-bottom: 40px;">发展历程</h3>
<!--         class="swiper-max"-->
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide
                  v-for="(item,index) in dataList"
                  :key="index"
                  style="position: static;"
          >
            <div class="display-row scroll-content">
              <div class="extra-content">
                <div class="extra-slider">
                  <div :class="'extra-slider-text extra-slider-text_'+index">

                  </div>
                </div>
                <div class="extra-line-middle">
                  <div class="extra-circle"></div>
                </div>
                <div class="extra-right">
                  <div class="extra-right-list">
                    <div v-for="(item1,index1) in item.wzlist" :key="index1" class="extra-right-item">
                      <div class="extra-right-title" v-if="index1==0">{{item.topTitle}}</div>
                      <div class="date-text" v-if="item1.time">{{item1.time.substr(0,4)}}年{{item1.time.substr(5,2)}}月</div>
                      <div class="content-text">
                        <p v-for="(item2,index2) in item1.titleList" :key="index2">· {{item2.title}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="extra-right-imgs" :style="imgLength>0?'':'display:none;'">
                    <div v-for="(item,index) in item.imgEntityList" :key="index">
                      <img :src="'/api'+item.imgUrl">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>


<script>
  import topNav from '@/components/base/top-nav'
  import {fetchList} from '@/api/visioncar.js'
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import $ from 'jquery';
  export default {
    name: "visioncar",
    components:{
      topNav,
      swiper,
      swiperSlide
    },
    data() {
      return {
        swiperOptions: {
          // direction: 'vertical',
          mousewheel: true,
          loop: false,
          autoHeight: true,
          slidesPerView: 1,
          slidesPerGroup: 1,
          loopFillGroupWithBlank: true,
          spaceBetween: 0,//间距
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swipe
          // observer:true,
          // autoplay: {
          //   delay: 3000,
          //   stopOnLastSlide: false,
          //   disableOnInteraction: false
          // },
          pagination: {
            el: '.swiper-pagination',    //与slot="pagination"处 class 一致
            clickable: true
          },
          // 设置点击箭头
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        },
        sliderLists: [
          {
            date:'2006年1月',
            p1:'· 公司与新城地产、中孚金悦激烈抢拍，最终以4.9亿元竞得吊桥路南侧的城中城地块(现嘉宏盛世项目),创造了当时常州土地市\n' +
                    '场总价及单价新高。',
          },
          {
            date:'2006年2月',
            p1:'· 常州嘉宏融科置业发展有限公司成立。',
          },
          {
            date:'2006年3月',
            p1:'· 原“泰富世纪大厦”正式更名为“嘉宏世纪大厦”',
          },
          {
            date:'2006年6月',
            p1:'· 嘉宏盛世项目被中国建设银行总行评为全国最有影响的200户\n' +
                    '项目之一，董事长刘康先生作为江苏房地产业唯一代表出席会\n' +
                    '议，并接受建行总行领导颁奖。',
          },
          {
            date:'2006年7月',
            p1:'· 嘉宏盛世项目正式开工。',
            p2:'· 嘉宏世纪大厦顺利交付。历时三年零九个月,以嘉宏名义开发的第一个项目正式全面竣工,实现了打造市中心CBD地标的美好愿望。',
            p3:'· 公司正式搬入嘉宏世纪大厦33楼。'
          },
          {
            date:'2006年8月',
            p1:'· 嘉宏盛世临时展示中心在嘉宏世纪大厦6楼正式开放。',
            p2:'',
            p3:''
          },
          {
            date:'2006年9月',
            p1:'· 常州市长王伟成视察公司并参观嘉宏盛世展示中心。',
            p2:'· 嘉宏盛世一期铂金座,怡景座举行开盘盛典。',
            p3:''
          },
          {
            date:'2006年10月',
            p1:'· 诺诚高第商业街签约暨开工开盘新闻发布会圆满举行。公司“诺\n' +
                    '诚高第”项目与香港华润苏果、常州商厦泰富百货在常州大酒店进\n' +
                    '行了盛大的签约仪式',
            p2:'',
            p3:''
          }
        ],
        imgList:['1.png','2.png','3.png','4.png'],
        dataList:[],
        imgLength:0
      }
    },
    computed:{
      mySwiper(){
        return this.$refs.mySwiper.swiper
      },
    },
    mounted() {
      this.fetchData()
    },
    methods: {
        fetchData() {
          fetchList().then(res=>{
            this.dataList = res.data;
            this.$nextTick(()=>{
              res.data.forEach((item,index)=>{
                if(item.title && item.title.length > 0){
                  let str = ''
                  for (let i = 0; i < item.title.length; i++) {
                    const char = item.title.charAt(i);
                    let china = char.match(/[\u4e00-\u9fa5]/g)
                    if(china && china.length > 0){
                      console.log(char);
                      str += '<span class="chinese-text">'+ char +'</span>'
                    }else{
                      str += '<span>'+ char +'</span>'
                    }
                  }
                  $('.extra-slider-text_'+index).html(str);
                }
                this.imgLength += item.imgEntityList.length
              })
            })
          })
        }
    }
  }
</script>

<style>
  @import "../../styles/visioncar.css";
</style>
